import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  GET_BANK_ACCOUNTS_URL,
  ADD_CUSTOMER_URL,
  EDIT_CUSTOMER_URL,
  RETRY_CUSTOMER_URL,
  UPLOAD_DOCUMENT_URL,
  GET_BANK_INSTITUTIONS_URL,
  GET_CLIENT_TOKEN_URL,
  BRAINTREE_ADD_URL,
  BRAINTREE_UPDATE_URL,
  BRAINTREE_RETRY_PAYMENT_URL,
  GET_SUBSCRIPTIONS_URL,
  CANCEL_SUBSCRIPTION_URL,
  DELETE_SUBSCRIPTION_CARD_URL,
  DELETE_CHECKBOOK_ACCOUNT_URL,
  DEFAULT_CHECKBOOK_ACCOUNT_URL,
  CHECKBOOK_LOGIN_TO_BANK_URL,
  CHECKBOOK_ADD_BANK_ACCOUNT_URL,
  CHECKBOOK_ADD_MFA_ANSWER_URL,
  CHECKBOOK_ADD_MD_AMOUNTS_URL
} from '@/constants/ApiConstants'

const state = {}

const getters = {}

const actions = {
  [action.GET_BANK_ACCOUNTS]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(GET_BANK_ACCOUNTS_URL)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.ADD_CUSTOMER]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(ADD_CUSTOMER_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.EDIT_CUSTOMER]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .putData(EDIT_CUSTOMER_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.RETRY_CUSTOMER]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(RETRY_CUSTOMER_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.UPLOAD_DOCUMENT]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(UPLOAD_DOCUMENT_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_BANK_INSTITUTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService
        .get(GET_BANK_INSTITUTIONS_URL)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
    [action.GET_CLIENT_TOKEN]() {
      return new Promise((resolve, reject) => {
        ApiService
          .get(GET_CLIENT_TOKEN_URL)
          .then((response) => {
              return resolve(response)
          })
          .catch(error => {
              return reject(error)
          })
      })
    },
  [action.BRAINTREE_ADD]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
          .post(BRAINTREE_ADD_URL, data)
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
  [action.BRAINTREE_UPDATE]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
          .putData(BRAINTREE_UPDATE_URL.replace(':creditCardToken', data.creditCardToken))
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
  [action.BRAINTREE_RETRY_PAYMENT]() {
    return new Promise((resolve, reject) => {
      ApiService
        .get(BRAINTREE_RETRY_PAYMENT_URL)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_SUBSCRIPTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService
          .get(GET_SUBSCRIPTIONS_URL)
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
  [action.CANCEL_SUBSCRIPTION]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(CANCEL_SUBSCRIPTION_URL)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.DELETE_SUBSCRIPTION_CARD]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
          .delete(DELETE_SUBSCRIPTION_CARD_URL.replace(':creditCardToken', data.creditCardToken))
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
  [action.DELETE_CHECKBOOK_ACCOUNT]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .delete(DELETE_CHECKBOOK_ACCOUNT_URL.replace(':bankId', data.bankId))
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.DEFAULT_CHECKBOOK_ACCOUNT]({commit}, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .putData(DEFAULT_CHECKBOOK_ACCOUNT_URL.replace(':bankId', data))
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.CHECKBOOK_LOGIN_TO_BANK]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(CHECKBOOK_LOGIN_TO_BANK_URL.replace(':institutionId', data.institutionId), data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.CHECKBOOK_ADD_BANK_ACCOUNT]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(CHECKBOOK_ADD_BANK_ACCOUNT_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.CHECKBOOK_ADD_MFA_ANSWER]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(CHECKBOOK_ADD_MFA_ANSWER_URL.replace(':institutionId', data.institutionId), data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.CHECKBOOK_ADD_MD_AMOUNTS]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
          .post(CHECKBOOK_ADD_MD_AMOUNTS_URL.replace(':institutionId', data.institutionId), data)
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
};

export default {
  state,
  actions,
  getters
}